'use client';
import { createTheme, Theme } from '@mui/material/styles';
import { MnoConfig } from '@/context/mno/types';

/**
 * Create a Material-UI theme based on MNO configuration
 * @param config - MNO configuration containing colors and other settings
 * @returns Material-UI theme object
 */
export function createMnoTheme(config: MnoConfig): Theme {
  return createTheme({
    typography: {
      fontFamily: 'var(--font-roboto)',
    },
    colorSchemes: { light: true },
    palette: {
      primary: {
        main: config.colors.primary,
      },
      secondary: {
        main: config.colors.secondary,
      },
    },
  });
}

